import React from 'react';
import TextverwaltungTab from '../../components/admin/TextverwaltungTab';

const TextePage = () => {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Texte</h1>
        <p className="text-sm text-gray-600">Feste Texte und Meldungen verwalten</p>
      </div>
      <TextverwaltungTab />
    </div>
  );
};

export default TextePage;
